import { useAuth } from '@framework/auth';
import { useBreadcrumbItem } from '@framework/ui';
import { FrontLoginSelectLegalEntityForm } from '../../components/legal-entity/FrontLoginSelectLegalEntityForm';
import { PageLayout } from '../../ui/layout/PageLayout';
import { LoginForm } from './component/LoginForm';

export interface ILoginPageProps {}

export function LoginPage(props: ILoginPageProps) {
  // In stato pre-loggato (token presente ma profilo "per conto di" non ancora
  // scelto) mostriamo la schermata di scelta; altrimenti il form di login.
  const { isPrelogged } = useAuth();

  // Aggiunge il breadcrumb
  // l'informazione viene utilizzata anche per nascondere il pulsante di login
  useBreadcrumbItem({
    path: '/login',
    title: 'Login',
  });

  return (
    <PageLayout largeContent>
      {isPrelogged ? <FrontLoginSelectLegalEntityForm /> : <LoginForm />}
    </PageLayout>
  );
}
